import request from '@/utils/request';
// 询价列表
export const getTaskEnquiry = (params: any) =>
  request({
    url: 'OrderTaskEnquiry/enquiryList',
    method: 'get',
    params
  });
  export const enquiryPass = (data: any) =>
  request({
    url: 'OrderTaskEnquiry/enquiryPass',
    method: 'put',
    data
  });